import * as cx from 'classnames';
import MenuGroup from 'mk2/components/menu/MenuGroup';
import Overlay from 'mk2/components/OverlayLoadable';
import * as React from 'react';
import styles from './MenuDropdown.mscss';

interface DropdownOwnProps {
    className: string;
    placement?: string;
    arrowOffsetLeft?: number | string;
    arrowOffsetTop?: number | string;
    positionTop?: number; // injected from react-overlay
    offsetTop?: number;
    positionRight?: number; // injected from react-overlay
    offsetRight?: number;
    show: boolean;

    onClick();
}

const Dropdown: React.StatelessComponent<DropdownOwnProps> = ({ children, positionTop = 0, offsetTop = 0, positionRight = 0, offsetRight = 8, show, onClick }) => (
    <div
        className={cx(styles.MenuDropdown__Dropdown, { [styles['MenuDropdown__Dropdown--show']]: show })}
        style={{
            top: positionTop + offsetTop,
            right: positionRight + offsetRight,
        }}
        onClick={onClick}
    >
        {children}
    </div>
);

interface OwnProps {
    className?: string;
    show: boolean;
    target: React.ReactNode | (() => React.ReactNode);
    onClose: () => void;
    container: React.ReactNode | (() => React.ReactNode);
    offsetTop?: number;
    offsetRight?: number;
}

interface ChildProps {
    align: 'left' | 'center' | 'right';
    className: string;
    itemClassName?: string;
}

class MenuDropdown extends React.Component<OwnProps> {

    public render() {
        const { className, show, onClose, children, offsetRight, offsetTop, ...rest } = this.props;

        if (!show) {
            return null;
        }

        return (
            <Overlay
                {...rest}
                show={show}
                onHide={onClose}
                placement="bottom"
            >
                <Dropdown
                    className={cx(styles.MenuDropdown__items, className, show && styles['MenuDropdown--show'])}
                    show={show}
                    onClick={onClose}
                    offsetTop={offsetTop}
                    offsetRight={offsetRight}
                >
                    {React.Children.map(children, (child) => {
                        if (React.isValidElement<ChildProps>(child)) {
                            const displayName = typeof child.type === 'string' ? child.type : (child.type as any).displayName;
                            const newProps: ChildProps = {
                                align: child.props.align || 'left',
                                className: cx(child.props.className, styles[`MenuDropdown__${displayName}`]),
                            };

                            if (displayName === 'MenuGroup' /* child.type === MenuGroup */) { // @see https://github.com/gaearon/react-hot-loader/issues/304
                                newProps.itemClassName = styles[`MenuDropdown__MenuGroup__MenuItem`];
                            }

                            return React.cloneElement(child, newProps);
                        } else {
                            return child;
                        }
                    })}
                </Dropdown>
            </Overlay>
        );
    }

}

export default MenuDropdown;
